<template>
  <main>
    <section class="box">
      <p class="title">联系我们</p>
      <div class="contact">
        <figure>
          <b><span>公司名称：</span><span>深圳市常顺旅行社有限公司</span></b>
          <b><span>公司地址：</span><span>深圳市罗湖区深南东路1027号文华大厦西座25层DE</span></b>
          <p><span>咨询热线1：</span><span>0755-22658484</span></p>
          <p><span>咨询热线2：</span><span>0755-22913255</span></p>
          <p><span>咨询热线3：</span><span>0755-82373078</span></p>
          <p><span>咨询热线4：</span><span>0755-22931183</span></p>
          <p><span>服务时间：</span><span>周一至周日 09:00-19:00</span></p>
          <p><span>签证邮寄：</span><span>深圳市罗湖区深南东路1027号文华大厦西座25层DE</span></p>
        </figure>
        <ul class="qrcode">
          <li><img src="@assets/img/cserweima.jpg" alt="" /><span>（微信公众号）</span></li>
          <li><img class="transform" src="@assets/img/qrcode.png" alt="" /><span>（官网二维码）</span></li>
        </ul>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  created() {
    this.scrollTo();
  }
}
</script>

<style>
main {
  background: #fff;

  .box {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto 30px;
    line-height: 2;

    .title {
      display: flex;
      align-items: center;
      height: 40px;
      margin: 30px 0 0;
      font-size: var(--fs_l);
      font-weight: bold;
      color: var(--main);
      border-bottom: 1px solid var(--bdr_light);
    }

    h2 {
      text-align: center;
      font-size: var(--fs_xl);
      font-weight: bold;
      color: var(--txt_bold);
      margin: 20px 0 20px;
    }

    .contact {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 80px 0;

      figure {
        font-size: var(--fs_m);
        font-weight: 200;

        b {
          display: block;
          font-size: var(--fs_xl);
          color: var(--txt_bold);
          font-weight: normal;

          &:last-of-type {
            margin: 0 0 30px;
          }
        }
      }

      .qrcode {
        display: flex;
        margin: 0 0 0 100px;

        li {
          text-align: center;
          display: inline-flex;
          flex-wrap: wrap;
          width: 120px;
          margin: 0 0 0 20px;

          img {
            width: 120px;
            height: 120px;

            &.transform {
              object-position: -5px -5px;
            }
          }

          span {
            width: 100%;
            display: flex;
            justify-content: center;
            font-size: var(--fs_m);
            color: var(--txt_placeholder);
            padding: 5px 0 0;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  main {
    /* padding: 0 !important; */
    box-sizing: border-box;

    .box {
      .contact {
        flex-direction: column;

        .qrcode {
          margin-top: 20px;
          margin-left: 0;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-around;
        }
      }
    }
  }
}
</style>